var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoDont(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.71929 7.28071C8.53069 7.09855 8.27808 6.99776 8.01589 7.00004C7.75369 7.00232 7.50288 7.10749 7.31747 7.29289C7.13206 7.4783 7.02689 7.72911 7.02461 7.99131C7.02234 8.25351 7.12313 8.50611 7.30529 8.69471L10.5983 11.9877L7.30529 15.2807C7.20978 15.373 7.1336 15.4833 7.08119 15.6053C7.02878 15.7273 7.00119 15.8585 7.00004 15.9913C6.99888 16.1241 7.02419 16.2558 7.07447 16.3787C7.12475 16.5016 7.199 16.6132 7.29289 16.7071C7.38679 16.801 7.49844 16.8753 7.62133 16.9255C7.74423 16.9758 7.87591 17.0011 8.00869 17C8.14147 16.9988 8.27269 16.9712 8.39469 16.9188C8.5167 16.8664 8.62704 16.7902 8.71929 16.6947L12.0123 13.4017L15.3053 16.6947C15.4939 16.8769 15.7465 16.9777 16.0087 16.9754C16.2709 16.9731 16.5217 16.8679 16.7071 16.6825C16.8925 16.4971 16.9977 16.2463 17 15.9841C17.0022 15.7219 16.9014 15.4693 16.7193 15.2807L13.4263 11.9877L16.7193 8.69471C16.9014 8.50611 17.0022 8.25351 17 7.99131C16.9977 7.72911 16.8925 7.4783 16.7071 7.29289C16.5217 7.10749 16.2709 7.00232 16.0087 7.00004C15.7465 6.99776 15.4939 7.09855 15.3053 7.28071L12.0123 10.5737L8.71929 7.28071Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoDont);
export default __webpack_public_path__ + "static/media/photo-dont.9f191f49b72dc76d30412c6d1b5e79ca.svg";
export { ForwardRef as ReactComponent };